import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()

export class SupplierConnectionService {

    baseurl = environment.apiBaseUrl;

    constructor(protected http: HttpClient) {
    }

    getSupplyConnections(id: any) {
        return this.http.get<any[]>(this.baseurl + 'pipeline/getsupplyconnections/' + id);
    }

    addsupplierconnection(supplierconnection: any) {
        return this.http.post<any[]>(this.baseurl + 'pipeline/addsupplierconnection', supplierconnection)
    }

    updatesupplierconnection(supplierconnection: any) {
        return this.http.post<any[]>(this.baseurl + 'pipeline/updatesupplierconnection', supplierconnection)
    }

    deleteSupplierConnection(customerConnectionId: any) {
        return this.http.delete<any>(this.baseurl + 'pipeline/deletesupplierconnection/' + customerConnectionId)
    }

}